// extracted by mini-css-extract-plugin
export const container = "footer-module--container--2LcPR";
export const content = "footer-module--content--3oSZ7";
export const left = "footer-module--left--3lTRX";
export const right = "footer-module--right--1ZcRA";